import React, { Component } from 'react';
import { LabeledInput } from '../../../../../shared/labeled-input/LabeledInput';
import { LabeledSelect } from '../../../../../shared/labeled-select/LabeledSelect';
import * as _ from 'lodash';
import './../../teams/add-team/AddTeamModalContent.scss';
import { BlueContainedButton } from '../../../../../shared/button/blue-contained-button/BlueContainedButton';

const statusDropdownOptions = [
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' }
];

export class EditUserModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: null,
            lastName: null,
            active: null
        };
    }

    componentDidMount() {
        if (this.props.user) {
            const { firstName, lastName, active } = this.props.user;

            this.setState({
                firstName,
                lastName,
                active: `${active}`
            });
        }
    }

    onEditUser = () =>
        _.isFunction(this.props.editTeam) && this.props.editTeam(this.state);

    handleNameInputChange = firstName =>
        this.setState({
            ...this.state,
            firstName
        });

    handleSurnameInputChange = lastName =>
        this.setState({
            ...this.state,
            lastName
        });

    handleStatusChange = active =>
        this.setState({
            ...this.state,
            active
        });

    isEditButtonDisabled = () =>
        !this.state.firstName && !this.state.lastName && !this.state.active;

    render = () => (
        <div className={'add-team-modal-content'}>
            <div className={'add-team-fields'}>
                <LabeledInput
                    label={'Name'}
                    onChange={this.handleNameInputChange}
                    className={'add-team row'}
                    value={this.state.firstName}
                />

                <LabeledInput
                    label={'Surname'}
                    onChange={this.handleSurnameInputChange}
                    className={'add-team row'}
                    value={this.state.lastName}
                />
                <LabeledSelect
                    label={'Status'}
                    options={statusDropdownOptions}
                    onChange={this.handleStatusChange}
                    value={this.state.active}
                    className={'add-team row'}
                />
            </div>
            <BlueContainedButton
                text={'Edit User'}
                onClick={() => this.onEditUser()}
                disabled={this.isEditButtonDisabled()}
            />
        </div>
    );
}
